<template>
    <div v-if="openHistoryAndMoreModal" class="history-and-more-modal d-flex justify-content-center" @click.self="closeHistoryAndMoreModal">
        <div class="inside-modal d-flex flex-column">
            <div class="button-group d-flex flex-row justify-content-center">
                <div class="button-one" :class="whichSide == 'history' ? 'button-active-to-left': ''" @click="changeWhichSide('history')">
                    <span>history</span>
                </div>
                <div class="button-two" :class="whichSide == 'more' ? 'button-active-to-right': ''" @click="changeWhichSide('more')">
                    <span>more</span>
                </div>
                <button class="close-button" @click="closeHistoryAndMoreModal">x</button>
            </div>
            <div v-if="whichSide == 'history'" class="d-flex flex-column justify-content-start">
                <div class="d-flex flex-row justify-content-start round-information-headers mx-md-5">
                    <div class="history-headers round-header">
                        round
                    </div>
                    <div class="history-headers date-header">
                        dates
                    </div>
                    <div class="history-headers ticket-header">
                        tickets
                    </div>
                </div>
                <div class="round-informations">
                    <div v-for="(round ,idx) in rounds" :key="idx" class="d-flex flex-row justify-content-start  my-2 mx-5 position-relative" style="direction: ltr">
                    <div class="round-insider">
                        {{round.roundNumber}}
                    </div>
                    <div class="round-insider windows-command-prompt text-white">
                        {{round.roundDate}}
                    </div>
                    <div class="round-insider text-center">
                        {{round.roundTickets}}
                    </div>
                    <div class="text-center">
                        <button class="arrow-button" @click="changeToMoreWithRound(round.roundNumber)">
                            <img src="../assets/images/arrow-right.png" alt="">
                        </button>
                    </div>
                    <div class="horizontal-line"></div>
                </div>
                </div>
                <div class="d-flex flex-row justify-content-center">
                    <button class="check-reward-button" @click="openCheckRewardModal()">
                        <img src="../assets/images/check-reward.webp" alt="">
                        check reward
                        <img src="../assets/images/check-reward.webp" alt="">
                    </button>
                </div>
            </div>
            <div v-if="whichSide == 'more'" class="d-flex flex-column justify-content-center">
                <div class="d-flex flex-row justify-content-center round-number" >
                    <button class="change-round-number" @click="roundNumber--">
                        &lt;
                    </button>
                    <span>round {{roundNumber}}</span>
                    <button class="change-round-number" @click="roundNumber++">
                        &gt;
                    </button>
                </div>
                <div class="d-flex flex-row justify-content-center your-tickets-text windows-command-prompt">
                    <span>Your tickets</span>
                </div>
                <div class="ticket-informations">
                    <div class="d-flex flex-column justify-content-center each-winners" v-for="i in 6" :key="i" style="direction: ltr">
                        <div class="d-flex flex-row justify-content-center mt-2 mx-2" >
                            <span class="buyed-numbers-round windows-command-prompt">#00{{i}}</span>
                            <div class="winner-numbers">
                                <img src="../assets/images/winning-eggs.webp" alt="">
                                <div class="numbers-positioning">
                                    <span class="first-winning-number">5</span>
                                    <span class="second-winning-number">3</span>
                                    <span class="third-winning-number">2</span>
                                    <span class="fourth-winning-number">4</span>
                                    <span class="fifth-winning-number">6</span>
                                    <span class="sixth-winning-number">9</span>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-center flex-row">
                            <div class="d-flex flex-row justify-content-center hr-line-for-more" ></div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center flex-row mt-5 windows-command-prompt">
                    <button class="get-more-tickets" @click="goBuyTicket">
                        Get More Tickets
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'history-and-more',
    props: {
        openHistoryAndMoreModal:{
            default: false,
            type: Boolean
        },
        whichSide:{
            type: String
        },
        roundNumber:{
            type: Number
        }
    },
    data(){
        return{
            rounds:[
                {
                roundNumber: 1 ,
                roundDate: '9.12.2021',
                roundTickets: 2,
                roundWin: true
                },
                {
                roundNumber: 2 ,
                roundDate: '10.12.2021',
                roundTickets: 1,
                roundWin: false
                },
                {
                roundNumber: 3 ,
                roundDate: '11.12.2021',
                roundTickets: 3,
                roundWin: true
                },
                {
                roundNumber: 4 ,
                roundDate: '12.12.2021',
                roundTickets: 2,
                roundWin: false
                },
                {
                roundNumber: 5 ,
                roundDate: '13.12.2021',
                roundTickets: 1,
                roundWin: false
                },
                {
                roundNumber: 4 ,
                roundDate: '14.12.2021',
                roundTickets: 3,
                roundWin: true
                },{
                roundNumber: 3 ,
                roundDate: '9.12.2021',
                roundTickets: 2,
                roundWin: true
                },
                {
                roundNumber: 2 ,
                roundDate: '10.12.2021',
                roundTickets: 1,
                roundWin: false
                },
                {
                roundNumber: 1 ,
                roundDate: '11.12.2021',
                roundTickets: 3,
                roundWin: true
                },
                {
                roundNumber: 2 ,
                roundDate: '12.12.2021',
                roundTickets: 2,
                roundWin: false
                },
                {
                roundNumber: 3 ,
                roundDate: '13.12.2021',
                roundTickets: 1,
                roundWin: false
                },
                {
                roundNumber: 4 ,
                roundDate: '14.12.2021',
                roundTickets: 3,
                roundWin: true
                },
                ]
        }
    },
    methods: {
        closeHistoryAndMoreModal(){
            this.$emit('HistoryAndMoreModal' ,false)
        },
        openCheckRewardModal(){
            this.$emit('HistoryAndMoreModal' ,false)
            this.$emit('checkRewardModal' ,true)
        },
        goBuyTicket(){
            this.$emit('HistoryAndMoreModal' ,false)
            this.$emit('buyTicketModal' , true)
        },
        changeWhichSide(changeSide){
            this.$emit('changeSide' , changeSide)   
        },
        changeToMoreWithRound(roundNumber){
            this.$emit('changeRoundNumber' , roundNumber)
            console.log(roundNumber , this.roundNumber)
            this.$emit('changeSide' , 'more')
        }
    }
    

}
</script>

<style scoped>
.history-and-more-modal{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1055;
    display: block;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    outline: 0;
}
.change-round-number{
    background: none;
    border: none;
    color: #ffe371;
    margin: 0 20px;
}
.arrow-button{
    background: none;
    border: none;
    position: absolute;
    top: 30%;
    right: 5%;
}
.arrow-button img {
    width: 26px;
}
.inside-modal{
    box-shadow: 2px 2px 5pt 5pt #ead287;
    top: 10%;
    margin: 20px;
    width: 758px;
    height: 800px;
    background: #0a0e1c;
    border-radius: 126px;
    border: solid 4.5px #ffe371;
    position: relative;
}
.round-number{
    font-size: 45px;
    color: #ffe371;
}
.history-headers{
    font-size: 30px;
    color: #ffcd00;
    width: 25%;
}
.go-to-reward-button{
    background: none;
    border: none;
    color: white;
    font-size: 30px;
}
.round-insider{
    font-size: 30px;
    color: #fcdf6b;
    padding: 5px 0;
    width: 25%;
}
.horizontal-line{
    border-radius: 126px;
    border: solid 2px #ffe371;
    background-color: #ffe371;
    position: absolute;
    bottom: -10px;
    width: 500px;
    height: 4px;
}
.check-reward-button{
    background-color: #2a396f;
    font-size: 45px;
    color: white;
    border-radius: 28.5px;
    border: none;
    margin-top: 30px;
    padding: 0 40px;
}
.buyed-numbers-round{
    font-size: 30px;
    color: white;
    margin: 10px 22px 0 0;
}
.hr-line-for-more{
    height: 5px;
    width: 80%;
    background-color: #fcdf6b;
    margin-top: 15px;
}
.your-tickets-text{
    font-size: 30px;
    color: white;
}
.winner-numbers{
    color: black;
    font-size: 44px;
    position: relative;
}
.first-winning-number{
    position: absolute;
    left: 4%;
    top: 0
}
.second-winning-number{
    position: absolute;
    left: 21%;
    top: 0
}
.third-winning-number{
    position: absolute;
    left: 38%;
    top: 0
}
.fourth-winning-number{
    position: absolute;
    left:55%;
    top: 0
}
.fifth-winning-number{
    position: absolute;
    left: 72%;
    top: 0
}
.sixth-winning-number{
    position: absolute;
    left: 90%;
    top: 0
}
.close-button{
    background: none;
    border: none;
    color: #fff;
    position: absolute;
    right: 50px;
    font-size: 41.5px;
    top: 60px;
}
.button-group{
    margin: 50px auto 20px auto;
    background: #2a396f;
    border-radius: 38px;
    padding: 0;
    color: white;
    font-size: 45px;
    height: 77px;
    width: 70%;
}
.button-one{
    width: 50%;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 38px;
}
.button-two{
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 50%;
    border-radius: 38px;
}
.round-informations{
    height: 440px;
    overflow: auto;
    direction: rtl;
    margin-left: 35px;
}
.round-informations::-webkit-scrollbar-track , .ticket-informations::-webkit-scrollbar-track
{
	border-radius: 10px;
	background-color: #FDDE6A;
}

.round-informations::-webkit-scrollbar , .ticket-informations::-webkit-scrollbar
{
	width: 11px;
}

.round-informations::-webkit-scrollbar-thumb , .ticket-informations::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	background-color: #C0A74A;
}
.get-more-tickets{
    margin-top: 50px;
    font-size: 28px;
    color: #ffe371;
    padding: 8px 75px;
    border-radius: 30.9px;
    border: solid 4.5px #ffe371;
    background: none;
    position: absolute;
    bottom: 50px;
}
.ticket-informations{
    direction: rtl;
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-left: 30px;
}
.each-winners{
    margin-left: -30px;
}
.round-information-headers{
    padding-left: 40px;
}
.button-active-to-right{
    background: #475dac;
    animation: left-to-right .5s
}
.button-active-to-left{
    background: #475dac;
    animation: right-to-left .5s
}
@keyframes left-to-right {
    from{
        transform: translateX(-50%);
    }
    to{
        transform: translateX(0)
    }
}
@keyframes right-to-left {
    from{
        transform: translateX(50%);
    }
    to{
        transform: translateX(0)
    }
}
@media (max-width: 780px) {
    .history-and-more-modal{
        top: 0;
    }
    .arrow-button{
        background: none;
        border: none;
        position: absolute;
        top: 30%;
        right: 0;
    }
    .round-number{
        font-size: 25px;
    }
    .get-more-tickets{
        padding: 10px;
    }
    .winner-numbers img{
        width: 90%;
        margin-top: 7px;
    }
    .winner-numbers{
        font-size: 25px;
    }
    .round-informations{
        margin-left: 5px !important;
    }
    .ticket-informations {
        margin-left: 10px;
        height: 250px;
    }
    .each-winners{
        margin-left: -10px;
    }
    .first-winning-number{
        position: absolute;
        left: 0;
        top: 0
    }
    .horizontal-line{
        width: 90%;
    }
    .check-reward-button{
        font-size: 25px;
    }
    .round-insider{
        font-size: 20px;
        width: 33%;
        margin-left: -3px;
    }
    .history-headers{
        font-size: 25px;
        width: 30%;
    }
    .second-winning-number{
        position: absolute;
        left: 15%;
        top: 0
    }
    .third-winning-number{
        position: absolute;
        left: 30%;
        top: 0
    }
    .fourth-winning-number{
        position: absolute;
        left:45%;
        top: 0
    }
    .fifth-winning-number{
        position: absolute;
        left: 60%;
        top: 0
    }
    .sixth-winning-number{
        position: absolute;
        left: 75%;
        top: 0
    }
    .close-button{
        top: 0;
        right: 10px;
    }
    .hr-line-for-more{
        width: 80%;
    }
    .first-winning-number, .second-winning-number , .third-winning-number , .fourth-winning-number , .fifth-winning-number ,.sixth-winning-number {
        padding: 10px;
    }
    .inside-modal{
        border-radius: 30px;
        top: 10px;
        height: 90vh;
    }
    .round-informations{
        height: 40vh;
    }
    .button-group{
        font-size: 25px;
        height: 60px !important;
        width: 90%;
    }
}
</style>